import css from '@emotion/css';
import styled from '@emotion/styled';

export const AnswersContainer = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 16px;

  font: 400 14px/20px 'Roboto';
  letter-spacing: 0.25px;
  color: var(--36363D);
`;

export const ButtonContainer = styled('div')`
  display: flex;
  justify-content: center;
  padding-top: 24px;
`;

export const AnswerComponent = styled('div')`
  display: flex;
  gap: 8px;
`;

export const SubmitButton = styled('button')<{ disabled?: boolean }>`
  display: block;
  padding: 6px 16px;

  font: 700 16px/24px Roboto;
  letter-spacing: 0.44px;
  color: var(--FFFFFF);
  background: var(--00B86D);

  border-radius: 4px;
  cursor: pointer;
  user-select: none;

  outline: none;
  border: none;

  ${props => props.disabled && css`
    background: 'var(--A8ABAE)';
  `}
`;

export const CustomAnswerTextAreaContainer = styled('div')`
  display: flex;
  justify-content: center;
  padding-top: 8px;
`;
